export default "__VITE_ASSET__DjN1z7Lw__"